import { Skeleton, Stack } from '@mui/material';
import ReactApexChart from 'react-apexcharts';
import { useSelector } from 'react-redux';

export default function HeighestLeadFooterSection() {
  const loading = useSelector((state) => state.crd.csdMonthWise.loading);
  const data = useSelector((state) => state.crd.csdMonthWise.data);
  const opt = {
    series: [
      {
        data: data?.reduce((acc, val) => {
          acc.push(val?.total_qualified_leads);
          return acc;
        }, []),
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 350,
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: 'end',
          horizontal: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
      },
      colors: [
        function ({ value }) {
          if (value > 700) return '#ef4444';
          if (value > 300) return '#f97316';
          return '#22c55e';
        },
      ],
    },
  };
  return (
    <Stack width={'100%'} maxWidth={{ xs: '100%', lg: 600 }} maxHeight={600}>
      {loading ? (
        <Skeleton height={600} width={'100%'} />
      ) : (
        <ReactApexChart options={opt.options} series={opt.series} type="bar" height={600} />
      )}
    </Stack>
  );
}
